import { useQuery } from '@tanstack/react-query';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';
import { validateUuid } from '@/utils/validate-uuid';

interface GetListActionPlanParams {
	organization_id: string;
	company_id: string;
	review_id: string;
	report_id: string;
	limit?: number;
	offset?: number;
}

const Service = Resolution886ReportService.getInstance();

export const useGetListsActionPlan = (params: GetListActionPlanParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id, params.review_id, params.report_id]);

	return useQuery({
		queryKey: ['get-action-plan', params],
		queryFn: () => Service.getListActionPlan(params),
		enabled: isEnabled
	});
};
